import { Modal, Button } from 'react-bootstrap';

interface DeleteModalProps {
    show: boolean;
    fileName: string | null;
    isDeleting: boolean;
    onHide: () => void;
    onConfirm: () => void;
    error: string | null; // Changed from string | undefined
}

export const DeleteModal: React.FC<DeleteModalProps> = ({
                                                            show,
                                                            fileName,
                                                            isDeleting,
                                                            onHide,
                                                            onConfirm,
                                                            error
                                                        }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error ? (
                    <div className="text-danger">{error}</div>
                ) : (
                    <p>Are you sure you want to delete "{fileName}"?</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="light"
                    onClick={onHide}
                    disabled={isDeleting}
                >
                    Cancel
                </Button>
                <Button
                    variant="danger"
                    onClick={onConfirm}
                    disabled={isDeleting || !!error}
                    className="d-inline-flex align-items-center"
                >
                    {isDeleting ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"/>
                            Deleting...
                        </>
                    ) : (
                        'Delete'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteModal;